import {RecipeState} from './recipe.reducers';
import {createFeatureSelector, createSelector} from '@ngrx/store';

export const recipeFeatureSelector = createFeatureSelector<RecipeState>('recipes');

export const getAllRecipes = createSelector(
  recipeFeatureSelector,
  state => state.recipes
);

export const isLoadingListRecipe = createSelector(
  recipeFeatureSelector,
  state => state.isLoadingList
);

export const isLoadingPatchRecipe = createSelector(
  recipeFeatureSelector,
  state => state.isLoadingPatch
);

export const getCurrentPageRecipe = createSelector(
  recipeFeatureSelector,
  state => state.page
);

export const getTotalItemsRecipe = createSelector(
  recipeFeatureSelector,
  state => state.totalElements
);

export const getPageSizeRecipe = createSelector(
  recipeFeatureSelector,
  state => !state?.filters?.size || state?.filters?.size.toString() === '' ? 9 : state?.filters?.size
);

export const getRecipe = createSelector(
  recipeFeatureSelector,
  state => state.recipe
);

export const isLoadingRecipe = createSelector(
  recipeFeatureSelector,
  state => state.isLoadingOne
);

export const getErrorDeleteRecipe = createSelector(
  recipeFeatureSelector,
  state => state.messageErrorDeleteRecipe
);
